/**
 * useBodyScrollLock — prevent background scrolling while an overlay
 * (drawer, modal, bottom sheet) is open.
 *
 * Uses the position:fixed technique so iOS Safari's rubber-band scroll is
 * also blocked, and restores the previous scroll position on unlock.
 */
import { useEffect } from 'react';

export function useBodyScrollLock(locked = true) {
  useEffect(() => {
    if (!locked) return;
    const scrollY = window.scrollY;
    const { overflow, position, top, width } = document.body.style;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    return () => {
      document.body.style.overflow = overflow;
      document.body.style.position = position;
      document.body.style.top = top;
      document.body.style.width = width;
      window.scrollTo(0, scrollY);
    };
  }, [locked]);
}
